<div class="element-container pointer-events-none absolute flex h-full w-full items-center justify-center">
  <slot></slot>
</div>
